/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S4_Li3Inputs */

const tr_iade_iptal_s4_li3 = /** @type {(inputs: Iade_Iptal_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmeti ticari veya mesleki amaçlarla satın alan Aboneler (tacirler ve bu amaçla hareket eden tüzel kişiler dâhil) bakımından 6502 sayılı Kanun gereği cayma hakkı uygulanmaz.`)
};

const en_iade_iptal_s4_li3 = /** @type {(inputs: Iade_Iptal_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Subscribers who purchase the service for commercial or professional purposes (including merchants and legal entities acting for such purposes), the right of withdrawal does not apply under Law No. 6502.`)
};

const de_iade_iptal_s4_li3 = /** @type {(inputs: Iade_Iptal_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Abonnenten, die den Dienst zu gewerblichen oder beruflichen Zwecken erwerben (einschließlich Kaufleuten und zu diesem Zweck handelnden juristischen Personen), gilt das Widerrufsrecht nach dem Gesetz Nr. 6502 nicht.`)
};

const ru_iade_iptal_s4_li3 = /** @type {(inputs: Iade_Iptal_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`К Абонентам, приобретающим услугу в коммерческих или профессиональных целях (включая коммерсантов и юридических лиц, действующих в таких целях), право на отказ согласно Закону № 6502 не применяется.`)
};

/**
* | output |
* | --- |
* | "For Subscribers who purchase the service for commercial or professional purposes (including merchants and legal entities acting for such purposes), the right..." |
*
* @param {Iade_Iptal_S4_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s4_li3 = /** @type {((inputs?: Iade_Iptal_S4_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S4_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s4_li3(inputs)
	if (locale === "de") return de_iade_iptal_s4_li3(inputs)
	if (locale === "ru") return ru_iade_iptal_s4_li3(inputs)
	return tr_iade_iptal_s4_li3(inputs)
});